(function () {

  function symbolConverter() {
    const isoCode = Shopify.currency.active;
    let discountElementsAll = document.querySelectorAll('.sc_simple-info__row .money.mw-price');
    discountElementsAll.forEach(discountElement => { 
      if(isoCode === 'SAR') {
        const priceString = discountElement.innerHTML.replace('SAR', '').replace('SR', '');
        if(!discountElement.querySelector('.rial'))
          discountElement.innerHTML = `<div class="rial"></div>  ${priceString} `;
      } 
      else if(isoCode === 'QAR' && Shopify.locale === 'ar') {
        const priceString = discountElement.innerHTML.replace('QAR', '');
        discountElement.innerHTML = priceString + ' ريال';
      } else if(isoCode === 'AED') {
        const priceString = discountElement.innerHTML.replace('Dhs.', '');
        if(!discountElement.querySelector('.dirham'))
          discountElement.innerHTML = '<div class="dirham"></div> ' + priceString;
      }
    });
  }

  window.addEventListener('DCART:appApi.initialized', function(e) {
    setTimeout(() => {
      symbolConverter();
      console.log('initial')
      document.documentElement.style.setProperty('--cart_sc_simple-info', 'block');
    }, 1000);

    dcartAPI.eventBus.subscribe(dcartAPI.Events.Discount.Apply, function(data) {
      const simpleInfo = document.querySelector('.sc_simple-info')
      document.documentElement.style.setProperty('--cart-price', 'none');
      document.querySelectorAll('.cart__price').forEach(cartPrice => {
        cartPrice.classList.add('spinner');
      })
    });

    dcartAPI.eventBus.subscribe(dcartAPI.Events.Discount.Calculated, async function(discountData) {
      document.documentElement.style.setProperty('--mw-price', 'none');
      document.querySelectorAll('.sc_simple-info__row div:last-child').forEach(scSimpleInfo => {
        scSimpleInfo.classList.add('spinner');
      })
      window.PXUTheme.jsAjaxCart.ajaxCartList();
      if(window.PXUTheme.jsCart != undefined) {
        window.PXUTheme.jsCart.updateCart();
      }

      setTimeout(() => {
        symbolConverter();
      console.log('update')
      }, 900);

      setTimeout(() => {
        document.documentElement.style.setProperty('--mw-price', 'flex');
        document.querySelectorAll('.sc_simple-info__row div:last-child').forEach(scSimpleInfo => {
          scSimpleInfo.classList.remove('spinner');
        })
        document.documentElement.style.setProperty('--cart-price', 'flex');
        document.querySelectorAll('.cart__price').forEach(cartPrice => {
        })
      }, 1000);

    });
  });

})();
